import { Nav } from "@/sections/Nav";
import { Hero } from "@/sections/Hero";
import { Film } from "@/sections/Film";
import { Stats } from "@/sections/Stats";
import { TeamCoach } from "@/sections/TeamCoach";
import { Events } from "@/sections/Events";
import { Academics } from "@/sections/Academics";
import { ProfileLinks } from "@/sections/ProfileLinks";
import { Contact } from "@/sections/Contact";
import { AdditionalInfo } from "@/sections/AdditionalInfo";
import { Footer } from "@/sections/Footer";

export default function Profile() {
  return (
    <div
      data-testid="profile-page"
      className="bg-[#0A0A0A] text-white flex flex-col w-full"
    >
      <Nav />
      <main className="flex flex-col w-full pb-12 md:pb-16">
        <Hero />
        <Film />
        <Stats />
        <TeamCoach />
        <Events />
        <Academics />
        <ProfileLinks />
        <Contact />
        <AdditionalInfo />
      </main>
      <Footer />
    </div>
  );
}
